import React, { memo } from 'react'

import { useUnit } from 'effector-react'

import { useCallback } from 'hooks'

import Input from 'components/_old/Input/Input.jsx'
import LabelInlineStyle from 'components/_old/LabelInlineStyle/LabelInlineStyle.jsx'
import Link from 'components/_old/Link/Link.jsx'

import { Paper } from 'components/atoms/Paper'
import { Validate } from 'components/atoms/Validate'

import { $form, $validation, setField, TRANSFER_HAS_BEEN_SUBMITTED_ERROR_TEXT } from '../../index'

const PlanNumber = memo(() => {
  const [form, validation] = useUnit([$form, $validation])

  const handleChange = useCallback(
    (_, value: string | null) =>
      setField({
        field: 'plan_number',
        value,
      }),
    [],
  )

  return (
    <Validate rules={validation.plan_number.rules}>
      {(isValid, brokenRule) => (
        <LabelInlineStyle
          labelText="Pension reference number"
          errorMessages={validation.plan_number.errors}
          size="small"
          multiline
          postfield={
            !isValid &&
            validation.plan_number.errors[brokenRule] === TRANSFER_HAS_BEEN_SUBMITTED_ERROR_TEXT && (
              <React.Fragment>
                Please{' '}
                <Link to="https://help.investengine.com/hc/en-gb/requests/new" blank hard>
                  contact us
                </Link>{' '}
                if you have questions or need to make changes to your existing transfer
              </React.Fragment>
            )
          }
        >
          <Paper top={4} data-test-id="pensionReferenceNumberInput">
            <Input type="text" onChange={handleChange} valid={isValid} required>
              {form.plan_number ?? ''}
            </Input>
          </Paper>
        </LabelInlineStyle>
      )}
    </Validate>
  )
})
PlanNumber.displayName = 'PlanNumber'

export { PlanNumber }
